var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6667 10.1111H27.8889V8.33333C27.8889 6.91885 27.327 5.56229 26.3268 4.5621C25.3266 3.5619 23.97 3 22.5556 3H8.33333C6.91885 3 5.56229 3.5619 4.5621 4.5621C3.5619 5.56229 3 6.91885 3 8.33333V22.5556C3 23.97 3.5619 25.3266 4.5621 26.3268C5.56229 27.327 6.91885 27.8889 8.33333 27.8889H10.1111V29.6667C10.1111 31.0812 10.673 32.4377 11.6732 33.4379C12.6734 34.4381 14.03 35 15.4444 35H29.6667C31.0812 35 32.4377 34.4381 33.4379 33.4379C34.4381 32.4377 35 31.0812 35 29.6667V15.4444C35 14.03 34.4381 12.6734 33.4379 11.6732C32.4377 10.673 31.0812 10.1111 29.6667 10.1111ZM8.33333 24.3333C7.86184 24.3333 7.40965 24.146 7.07626 23.8126C6.74286 23.4792 6.55556 23.0271 6.55556 22.5556V8.33333C6.55556 7.86184 6.74286 7.40965 7.07626 7.07626C7.40965 6.74286 7.86184 6.55556 8.33333 6.55556H22.5556C23.0271 6.55556 23.4792 6.74286 23.8126 7.07626C24.146 7.40965 24.3333 7.86184 24.3333 8.33333V10.1111H15.4444C14.03 10.1111 12.6734 10.673 11.6732 11.6732C10.673 12.6734 10.1111 14.03 10.1111 15.4444V24.3333H8.33333Z",
    fill: "#74CAA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalDuplicate);
export default __webpack_public_path__ + "static/media/modal-duplicate.a66b44c0eb8728ac760ce9f8fa812af0.svg";
export { ForwardRef as ReactComponent };